import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import { Button, Paper, TextField } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { getSession, isElectron } from '@jbrowse/core/util';
import { storeBlobLocation } from '@jbrowse/core/util/tracks';
var useStyles = makeStyles()(function (theme) {
  return {
    textbox: {
      width: '100%'
    },
    paper: {
      margin: theme.spacing(),
      padding: theme.spacing()
    },
    submit: {
      marginTop: 25,
      marginBottom: 100,
      display: 'block'
    }
  };
});
export default function MultiWiggleWidget(_ref) {
  var model = _ref.model;
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    val = _useState2[0],
    setVal = _useState2[1];
  var _useState3 = useState('MultiWiggle ' + Date.now()),
    _useState4 = _slicedToArray(_useState3, 2),
    trackName = _useState4[0],
    setTrackName = _useState4[1];
  return React.createElement(Paper, {
    className: classes.paper
  }, React.createElement("ul", null, React.createElement("li", null, "Enter list of URLs for bigwig files in the textbox"), React.createElement("li", null, "Or, use the button below the text box to select files from your computer")), React.createElement(TextField, {
    multiline: true,
    rows: 10,
    value: val,
    onChange: function onChange(event) {
      return setVal(event.target.value);
    },
    placeholder: 'Paste list of URLs here, or use file selector below',
    variant: "outlined",
    className: classes.textbox
  }), React.createElement(Button, {
    variant: "outlined",
    component: "label"
  }, "Choose Files from your computer", React.createElement("input", {
    type: "file",
    hidden: true,
    multiple: true,
    onChange: function onChange(_ref2) {
      var target = _ref2.target;
      var res = Array.from((target === null || target === void 0 ? void 0 : target.files) || []).map(function (file) {
        return {
          type: 'BigWigAdapter',
          bigWigLocation: isElectron ? {
            localPath: file.path,
            locationType: 'LocalPathLocation'
          } : storeBlobLocation({
            blob: file
          }),
          source: file.name
        };
      });
      setVal(JSON.stringify(res, null, 2));
    }
  })), React.createElement(TextField, {
    value: trackName,
    onChange: function onChange(event) {
      return setTrackName(event.target.value);
    },
    helperText: "Track name"
  }), React.createElement(Button, {
    variant: "contained",
    className: classes.submit,
    onClick: function onClick() {
      var _a;
      var session = getSession(model);
      var trackId = ["".concat(trackName.toLowerCase().replace(/ /g, '_'), "-").concat(Date.now()), "".concat(session.adminMode ? '' : '-sessionTrack')].join('');
      // allow list of bigwigs in JSON format or line-by-line
      var bigWigs;
      try {
        bigWigs = JSON.parse(val);
      } catch (e) {
        bigWigs = val.split(/\n|\r\n|\r/);
      }
      var obj = typeof bigWigs[0] === 'string' ? {
        bigWigs: bigWigs
      } : {
        subadapters: bigWigs
      };
      session.addTrackConf({
        trackId: trackId,
        type: 'MultiQuantitativeTrack',
        name: trackName,
        assemblyNames: [model.assembly],
        adapter: _objectSpread({
          type: 'MultiWiggleAdapter'
        }, obj)
      });
      (_a = model.view) === null || _a === void 0 ? void 0 : _a.showTrack(trackId);
      model.clearData();
      session.hideWidget(model);
    }
  }, "Submit"), React.createElement("p", null, "Additional notes: "), React.createElement("ul", null, React.createElement("li", null, "The list of bigwig files in the text box can be a list of URLs, or a list of elements like", ' ', React.createElement("code", null, "[{\"type\":\"BigWigAdapter\",\"bigWigLocation\":{\"uri\":\"http://host/file.bw\"}, \"color\":\"green\",\"source\":\"name for subtrack\"}]"), ' ', "to apply e.g. the color attribute to the view"), React.createElement("li", null, "Adding local files will update the textbox with JSON contents that are ready to submit with the \"Submit\" button")));
}